module.exports = __webpack_public_path__ + "static/media/ic-back.4345e659.svg";